import DiscoverRadioGroup from './DiscoverRadioGroup';

export default DiscoverRadioGroup;
